import React, {useEffect} from "react";

const useScroll = (callback) => {
    const listener = (event) => {
        callback(event);
    };
    
    useEffect(() => {
        window.addEventListener("scroll", listener);
        
        return () => {
            window.removeEventListener("scroll", listener);
        }
    }, [callback]);
};

export default useScroll;